module.exports = __webpack_public_path__ + "static/media/brush-2@1x.461d5dc1.png";